import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from 'react'
import {
  isHidePhonesEnabled,
  setHidePhonesEnabled,
  subscribeHidePhones,
} from 'src/lib/demo-privacy'

interface DemoPrivacyContextValue {
  hidePhones: boolean
  setHidePhones: (enabled: boolean) => void
}

const DemoPrivacyContext = createContext<DemoPrivacyContextValue>({
  hidePhones: false,
  setHidePhones: () => {},
})

export const DemoPrivacyProvider = ({ children }: { children: ReactNode }) => {
  const [hidePhones, setHidePhonesState] = useState(isHidePhonesEnabled)

  useEffect(() => subscribeHidePhones(() => setHidePhonesState(isHidePhonesEnabled())), [])

  const setHidePhones = useCallback((enabled: boolean) => {
    setHidePhonesEnabled(enabled)
    setHidePhonesState(enabled)
  }, [])

  const value = useMemo(
    () => ({
      hidePhones,
      setHidePhones,
    }),
    [hidePhones, setHidePhones],
  )

  return <DemoPrivacyContext.Provider value={value}>{children}</DemoPrivacyContext.Provider>
}

export const useDemoPrivacy = () => useContext(DemoPrivacyContext)
